import { fetchUserById } from "@/lib/userApi";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router";

export function useUserById(userId: string, enabled = true) {
  const navigate = useNavigate();

  const { data, isLoading, error } = useQuery({
    queryKey: ['user', userId],
    queryFn: () => fetchUserById(userId),
    enabled: !!userId && enabled,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    
    if (!isLoading && (data === null || data === undefined)) {
      navigate('/', { replace: true });
    }
  }, [data, isLoading, navigate]);

  return data;
}